import axios, { AxiosInstance } from 'axios'
import Cookies from 'universal-cookie/es6'

import { STORAGEKEYS } from '../../common/keys'
import { affiliatePartnersNames } from '../../pages/AffiliatePage/affiliatePartnersData'
import { SessionStorage } from '../../common/cookie-storage'
import { Environment } from '../../environment/app-settings'


//#region YouAffService Instance
let youAffInstance: YouAffService
//#endregion

class YouAffService {
   private readonly _youAffCallbackBaseApiUrl = 'https://youaff.go2cloud.org';
   private readonly _PRD_youAffAffiliateUrlPath = "/aff_lsr";

   constructor() {
    if (youAffInstance) { //SINGLETON DESIGN PATTERN
       throw new Error("New instance cannot be created!!");
    }
 
    youAffInstance = this;
   }
   
   /**
    * Metoda pomocnicza zwracająca gotowy link do postbacka, wraz z odpowiednimi parametrami zapytania (query params)
   */
   private _preparePostbackLink (): string | undefined  {
      const currentAppUrl = window.location.origin
      
      const cookie = new Cookies();
      const currentAffiliateCookie = cookie.get(STORAGEKEYS.FORM_AFFILIATE_DATA_COOKIE)
      const sessionStorage = new SessionStorage()

      if(Boolean(currentAffiliateCookie)){
         if(currentAffiliateCookie.partnerId === affiliatePartnersNames.YouAff){   
            if(currentAppUrl.includes(Environment.OPENA_FORM_PRD_URL)){ // LINK AFILIACYJNY DLA PRODUKCJI
               const alphaId = sessionStorage.get(STORAGEKEYS.SET_ALPHA_ID) //!! IMPORTANT - METODA TA MUSI ZOSTAĆ WYWOŁANA NA ETAPIE GDZIE NUMER WNIOSKU JEST ZNANY
   
               const youAffCallbackQueryParams = new URLSearchParams({
                  offer_id: "22", // WARTOŚĆ STAŁA
                  adv_sub: alphaId,
                  transaction_id: currentAffiliateCookie.urlParams.click_id,
               })
         
               return `${this._youAffCallbackBaseApiUrl + this._PRD_youAffAffiliateUrlPath}?${youAffCallbackQueryParams.toString()}`
            }
         }
      }
 
      return undefined
   }
 
   /**
    * Funkcja obsługująca mechanizm POSTBACK partnera YouAff dla LEAD'A
   */
   public async sendLeadPostback(): Promise<void> {
      const currentAppUrl = window.location.origin
      const youAffCallbackUrl = this._preparePostbackLink()

      if(currentAppUrl.includes(Environment.OPENA_FORM_PRD_URL) && youAffCallbackUrl !== undefined){ // POSTBACK wykonujemy TYLKO NA PRODUKCJI
         await fetch(youAffCallbackUrl, { mode: 'no-cors', method: "GET" }).catch(e => console.error("Nie udało się wykonać zapytania Postback dla partnera YouAff."))   
      }

      return
   }
}
 
let youAffService = Object.freeze(new YouAffService())//SINGLETON DESIGN PATTERN
export default youAffService;